import {
  getZodiac,
  getStarSign,
  getEraLabel,
  getAdjacentEras,
} from './derive.js';
import { hashString, seededRandom } from './seededRandom.js';

export const NAME_ENGINE_VERSION = 'v1';

export function selectFromDerived(pool, dataVersion, derived) {
  const {
    gender,
    mood,
    zodiacId,
    backgroundId,
    eraLabel,
    retryCount = 0,
  } = derived;

  const byGender = pool.filter((n) => n.gender_lean === gender);
  let byEra = byGender.filter((n) => n.era_tags.includes(eraLabel));
  if (byEra.length === 0) {
    for (const adj of getAdjacentEras(eraLabel)) {
      byEra = byGender.filter((n) => n.era_tags.includes(adj));
      if (byEra.length > 0) break;
    }
  }
  if (byEra.length === 0) byEra = byGender;

  const moodMatch = byEra.filter((n) => n.vibe_mood === mood);
  const candidates = moodMatch.length > 0 ? moodMatch : byEra;

  const seedKey = [
    NAME_ENGINE_VERSION,
    dataVersion,
    gender,
    mood,
    zodiacId,
    backgroundId,
    eraLabel,
    retryCount,
  ].join('|');
  const rng = seededRandom(hashString(seedKey));
  const name = candidates[Math.floor(rng() * candidates.length)];

  return {
    name,
    backgroundId,
    zodiacId,
    eraLabel,
    versions: { engine: NAME_ENGINE_VERSION, data: dataVersion },
  };
}

/**
 * 이름 선택 — 결정론(동일 입력 = 동일 결과), retryCount로 "다시 만들기"
 * @param {Array} pool  namesTier0.json의 names 배열
 * @param {string} dataVersion  candidate_data_version
 * @param {{ birthYear, birthMonth, birthDay, gender, mood, retryCount }} input
 */
export function selectName(pool, dataVersion, input) {
  return selectFromDerived(pool, dataVersion, {
    gender: input.gender,
    mood: input.mood,
    zodiacId: getZodiac(input.birthYear),
    backgroundId: getStarSign(input.birthMonth, input.birthDay),
    eraLabel: getEraLabel(input.birthYear),
    retryCount: input.retryCount ?? 0,
  });
}
